/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum TicketByProcessDefinitionKind {
    Default = '0',
    Linkable = 1,
}
